// Meta Pixel merkezi utility — tüm Meta event'leri buradan geçer.
// Şu an aktif event: PageView. İleride işletme kaydı tamamlanınca:
//   import { trackMetaEvent } from "@/lib/metaPixel";
//   trackMetaEvent("CompleteRegistration");

const fbq = (...args) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq(...args);
  }
};

let lastTrackedPath = null;

// SPA'da her rota değişiminde bir kez PageView gönderir (ayni path'i tekrar göndermez).
export const trackPageView = (path) => {
  if (path === lastTrackedPath) return;
  lastTrackedPath = path;
  fbq("track", "PageView");
};

// Standart/özel Meta event tetikleyici (ör. "CompleteRegistration").
// params verilmezse birebir fbq('track', event) formunda gönderilir (standart event uyumu).
export const trackMetaEvent = (event, params) => {
  if (params === undefined || params === null) fbq("track", event);
  else fbq("track", event, params);
};

// Bir kez gönderim garantili event — StrictMode, re-render, çift submit ve
// sayfa yenileme kaynaklı kopyaları sessionStorage bayrağıyla engeller.
// key: ayni oturumda farkli kayitlari ayirmak icin (ör. e-posta).
export const trackMetaEventOnce = (event, params, key) => {
  const storageKey = `mp_${event}${key ? `_${key}` : ""}`;
  try {
    if (typeof window !== "undefined" && window.sessionStorage?.getItem(storageKey)) return;
    if (typeof window !== "undefined") window.sessionStorage?.setItem(storageKey, "1");
  } catch (e) { /* storage erisilemezse tek seferlik in-memory davranis */ }
  trackMetaEvent(event, params);
  console.debug(`[MetaPixel] ${event} gonderildi`, params || "");
};
